import React, { useEffect } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import axios from "axios";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const API_URL = process.env.REACT_APP_FUNCTION_CONSUME_LOGS_GOOGLEMAPS;

const geocodeAddress = async (address, city = "", state = "") => {
  if (!address) throw new Error("Address is required.");

  try {
    const response = await axios.get(API_URL, {
      params: {
        address,
        city,
        state,
        country: "CO",
        endpointType: "geocode",
      },
    });

    const payload = response.data;
    const googleData = payload.data;

    if (googleData.status === "OK" && googleData.results[0]) {
      return googleData.results[0].geometry.location;
    }

    // Fallback con city/state
    const fallbackResp = await axios.get(API_URL, {
      params: {
        address: `${city}, ${state}`,
        country: "CO",
        endpointType: "geocode",
      },
    });

    const fallbackPayload = fallbackResp.data;
    const fallbackData = fallbackPayload.data;

    if (fallbackData.status === "OK" && fallbackData.results[0]) {
      return fallbackData.results[0].geometry.location;
    }

    throw new Error(
      "Error fetching location. Status: " +
        fallbackData.status
    );
  } catch (err) {
    console.error("Error in geocoding:", err.message);
    throw err;
  }
};



const containerStyle = {
  marginTop: "10px",
  width: "300px",
  height: "302px",
  borderRadius: "15px",
  overflow: "none",
};

const Map = ({ address, city, state }) => {
  const [center, setCenter] = React.useState({
    lat: 4.570868,
    lng: -74.297333,
  });

  const mapOptions = {
    streetViewControl: false, // Desactiva el control de Street View
    scaleControl: false, // Desactiva el control de escala
    mapTypeControl: false, // Desactiva el control para cambiar el tipo de mapa
    panControl: false, // Desactiva el control de paneo
    zoomControl: false, // Desactiva los controles de zoom
    fullscreenControl: false, // Desactiva el botón de pantalla completa
    gestureHandling: "none", // Desactiva el gesto de desplazamiento
  };

  useEffect(() => {
    if (address) {
      geocodeAddress(address, city || "", state || "", apiKey)
        .then(setCenter)
        .catch(console.error);
    }
  }, [address]);
  return (
    <LoadScript googleMapsApiKey={apiKey}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={17}
        options={mapOptions}
      >
        <Marker position={center} />
      </GoogleMap>
    </LoadScript>
  );
};

export default React.memo(Map);
